// ═══════════════════════════════════════════════════════════════
// MainStreet — My Business Page
// Business Owner's view: resolves their org and shows OrgDetail
// ═══════════════════════════════════════════════════════════════

import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Paper, Text, Title, Stack, Loader, Center } from '../../components/gab/GabComponents';
import { IconBuilding } from '@tabler/icons-react';
import { useMyOrg } from '../../hooks/useMyOrg';
import { useMainStreetStore } from '../../store/mainstreetStore';

export default function MyBusiness() {
  const { loadingOrgs: loading, loadOrganizations } = useMainStreetStore();
  const myOrg = useMyOrg();

  useEffect(() => {
    loadOrganizations();
  }, []);

  if (loading) {
    return (
      <Center py="xl">
        <Loader size="lg" />
      </Center>
    );
  }

  // If org is found, redirect to that org's detail page
  if (myOrg) {
    return <Navigate to={`/mainstreet/org/${myOrg.id}`} replace />;
  }

  // No org linked to user
  return (
    <Paper withBorder p="xl" mt="xl">
      <Stack align="center" gap="md">
        <IconBuilding size={48} color="#939598" />
        <Title order={3}>No Organization Linked</Title>
        <Text c="dimmed" ta="center">
          Your account is not currently linked to any organization in MainStreet.
          Please contact your administrator to link your email to your business profile.
        </Text>
      </Stack>
    </Paper>
  );
}
